import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {IState} from '../store/reducers';
import {IBlock} from '../models';

interface UseReportIsDirty {
  isDirty: boolean;
  areBlocksDirty: boolean;
  isReportDirty: boolean;
}

export function useReportIsDirty(): UseReportIsDirty {
  const reportIsDirty = useSelector((state: IState) => state.reportForm.isDirty);
  const blocks = useSelector((state: IState) => state.block.blocks);
  const blocksAreDirty = useMemo(() =>
    blocks?.some((block: IBlock) => block?.is_dirty || false) || false, [blocks]);

  return {
    isDirty: (reportIsDirty || blocksAreDirty),
    areBlocksDirty: blocksAreDirty,
    isReportDirty: reportIsDirty,
  };
}
